const FOCUSABLE =
  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

const modalAccessibilityInit = () => {
  const modals = document.querySelectorAll('.modal');

  modals.forEach((modalEl) => {
    let triggerElement = null;

    modalEl.addEventListener('show.bs.modal', (event) => {
      const related = event.relatedTarget;
      if (related && related instanceof HTMLElement) {
        triggerElement = related;
      } else if (document.activeElement instanceof HTMLElement) {
        triggerElement = document.activeElement;
      }

      modalEl.addEventListener(
        'shown.bs.modal',
        () => {
          const closeBtn = modalEl.querySelector('.tt-modal__close, .btn-close');
          const firstFocusable = modalEl.querySelector(FOCUSABLE);
          const target = closeBtn || firstFocusable;
          if (target instanceof HTMLElement) {
            target.focus();
          }
        },
        { once: true }
      );
    });

    modalEl.addEventListener('hidden.bs.modal', () => {
      if (triggerElement && document.contains(triggerElement)) {
        triggerElement.focus();
      }
      triggerElement = null;
    });
  });

  document.querySelectorAll('.modal a[href="#contact"]').forEach((link) => {
    link.addEventListener('click', () => {
      const modalEl = link.closest('.modal');
      if (modalEl && window.bootstrap?.Modal) {
        const instance = window.bootstrap.Modal.getInstance(modalEl);
        if (instance) {
          instance.hide();
        }
      }
      // Bootstrap dismiss cancels the link, so open Contact explicitly.
      if (window.location.hash !== '#contact') {
        window.location.hash = 'contact';
      }
    });
  });
};

export default modalAccessibilityInit;
